import { useMutation } from '@tanstack/react-query';
import { toast } from '@huspy/forge/shared';
import queryClient from '@app/queryClient';
import { trackAmplitudeEvent } from '@shared/analytics/amplitude';
import { USER_EVENTS } from '@shared/analytics/events';
import { proposalApi } from '@modules/proposals/api';

const useSelectProposalBankProducts = (showSuccessMessage: boolean = true) => {
  const {
    error, mutate, isPending, mutateAsync,
  } = useMutation({
    mutationKey: ['updateSelectProposalBankProducts'],
    mutationFn: ({ proposalExternalId, bankProductsIds }: { proposalExternalId: string, bankProductsIds: string[] }) => {
      trackAmplitudeEvent(USER_EVENTS.PROPOSAL.PROPOSAL_GENERATION_ATTEMPTED, {
        useContext: true,
        addToContext: true,
        proposal_id: proposalExternalId,
        bank_products: bankProductsIds,
      });
      return proposalApi.selectBankProducts(proposalExternalId, bankProductsIds);
    },
    onSuccess: (_, req) => {
      trackAmplitudeEvent(USER_EVENTS.PROPOSAL.PROPOSAL_GENERATION_COMPLETED, { useContext: true });
      queryClient.refetchQueries({ queryKey: ['proposal', req.proposalExternalId] });
      queryClient.invalidateQueries({ queryKey: ['proposalPreview', req.proposalExternalId] });

      if (showSuccessMessage) {
        toast('info', { message: 'Bank products selected' });
      }
    },
    onError: (e) => {
      trackAmplitudeEvent(USER_EVENTS.PROPOSAL.PROPOSAL_GENERATION_FAILED, {
        useContext: true,
        error_message: e.data?.bank_products_external_ids?.errors?.[0],
      });
      toast('error', { message: e.data?.bank_products_external_ids?.errors?.[0] });
    },
  });

  return {
    mutate, error, isPending, mutateAsync,
  };
};

export default useSelectProposalBankProducts;
